// extracted by mini-css-extract-plugin
export default {"MaterialDetailsContainer":"ViewMaterial_MaterialDetailsContainer__Ko4QY"};